import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { startBuscaOrdenPagoIDV2 } from '../../../../context/actions/pagos2Actions';

export default function BuscarPorOrdenPagoID() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [ordenPagoID, setOrdenPagoID] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!ordenPagoID) return;

    setLoading(true);

    try {
      const respuesta = await dispatch(startBuscaOrdenPagoIDV2(ordenPagoID));

      if (respuesta.success) {
        history.push(`/ordenesPagoV2/detalle/${ordenPagoID}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <Input
      placeholder="OP ID"
      value={ordenPagoID}
      onChange={(e) => setOrdenPagoID(e.target.value)}
      onKeyPress={handleKeyPress}
      type="number"
      style={{ width: 95 }}
      suffix={
        <SearchOutlined
          onClick={handleClick}
          className="ant-input-search-icon"
        />
      }
    />
  );
}
